import EventBus from "../../../../util/EventBus";
import Applet from "../../Applet";
import PlatformDetailDialog from "../../../../components/PlatformDetailDialog";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {prepareBuffer} from "../../../../util/Buffer";


class ProjectPlanPhaseMilestoneReferenceFormApplet extends Applet {
    state = {
        Name: "ProjectPlanPhaseMilestoneReferenceFormApplet",
        Actions: {
            View: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "ReferenceType",
                            },
                            {
                                id: "ParentUSID",
                            },
                            {
                                id: "DocumentRevisionUSID",
                            },
                            {
                                id: "Comment",
                            }
                        ]
                    }
                ]
            },
            New: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "ReferenceType",
                            },
                            {
                                id: "ParentUSID",
                            },
                            {
                                id: "DocumentIDPlusRevision",
                            },
                            {
                                id: "Comment",
                            }
                        ]
                    }
                ]
            },
            Edit: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "ReferenceType",
                            },
                            {
                                id: "ParentUSID",
                            },
                            {
                                id: "DocumentIDPlusRevision",
                            },
                            {
                                id: "Comment",
                            }
                        ]
                    }
                ]
            },
            Delete: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "ReferenceType",
                            },
                            {
                                id: "ParentUSID",
                            },
                            {
                                id: "DocumentIDPlusRevision",
                            },
                            {
                                id: "Comment",
                            }
                        ]
                    }
                ]
            }
        },
        Layout: {
            totalWidth: "36em",
        },
        Controls: {
            ReferenceType: {
                id: "ReferenceType",
                enterpriseComponentAttribute: "ReferenceType",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    label: "Reference Type",
                    size: "small"
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            },
            ParentUSID: {
                id: "ParentUSID",
                enterpriseComponentAttribute: "ParentUSID",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    label: "Group",
                    size: "small"
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            },
            DocumentIDPlusRevision: {
                id: "DocumentIDPlusRevision",
                enterpriseComponentAttribute: "DocumentIDPlusRevision",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    label: "Document",
                    size: "small"
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            },
            Comment: {
                id: "Comment",
                enterpriseComponentAttribute: "Comment",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    label: "Comment",
                    size: "small"
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
        }
    };

    cancel() {
        super.cancel();

        if (this.props.defaultAction === "Edit") {
            EventBus.components.emit("project-plan-phase-milestone-reference-form-applet-cancel");
        } else {
            EventBus.components.emit("project-plan-phase-milestone-reference-form-applet-cancel");
        }
    };

    canSave() {
        if (!this.getEnterpriseComponent().isNewMode()) {
            return true;
        }
        if (this.getEnterpriseComponent().getBuffer().get(1).length <= 1) {
            return true;
        }
        let buffer = prepareBuffer(this.getEnterpriseComponent());
        let insertedRow = buffer[0];

        for (let i = 1; i < this.getEnterpriseComponent().getBuffer().size + 1; i++) {
            let buffer = this.getEnterpriseComponent().getBuffer().get(i);

            for (let j = 0; j < buffer.length; j++) {
                if (i === 1 && j === 0) continue;

                if (buffer[j].get("DocumentUSID") === insertedRow.get("DocumentUSID")) {
                    return false;
                }
            }
        }
        return true;
    }

    setAction(mode) {
        super.setAction(mode);

        if (mode === "Save Completed") {
            if (this.props.defaultAction === "Edit") {
                EventBus.components.emit("project-plan-phase-milestone-reference-form-applet-save");
            } else {
                EventBus.components.emit("project-plan-phase-milestone-reference-form-applet-save");
            }
        }
    };

    savePrevented() {
        this.getEnterpriseComponent().executeInsertRollback()
        this.setState({savePrevented: true})
    };

    render() {
        if (this.state.savePrevented) {
            return (
                <>
                    <Dialog open={true} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">
                            Alert!
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                This record is already in the list of references. Please select another.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.setState({savePrevented: false})} autoFocus>
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            )
        } else {
            return <PlatformDetailDialog applet={this}
                               layout={this.state.Layout}
                               controls={this.state.Controls}
                               actions={this.state.Actions}
                               title="Reference"
                               enterpriseComponent={this.getEnterpriseComponent()}
                               action={this.props.defaultAction}
                               errorReportingMethod="RealTime" />
        }
    }
}

export default ProjectPlanPhaseMilestoneReferenceFormApplet;
